import HttpService from "@core/services/http/http.service";
import {
  ChangeInfoResponse,
  ChangePasswordResponse,
  GetDetailResponse,
  GetListResponse,
  UpdateInfoRequest,
  User,
} from "@app/types";
import {
  RequestContentType,
  RequestParams,
  Signal,
} from "@core/services/http/http.type";

class _UserService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<User>>("/user/api/v1/users", {
      queryParams: { ...requestParams },
      signal,
    });
  }

  public getInfo(signal?: Signal) {
    return HttpService.get<GetDetailResponse<User>>("/user/api/v2/auth/info", {
      signal,
    });
  }

  public changeInfo(updateInfoRequest: UpdateInfoRequest) {
    return HttpService.patch<ChangeInfoResponse>("/user/api/v2/auth/info", {
      body: { ...updateInfoRequest },
    });
  }

  public changePassword(oldPassword: string, newPassword: string) {
    return HttpService.post<ChangePasswordResponse>(
      "/user/api/v1/auth/change-password",
      {
        body: { oldPassword, newPassword },
      }
    );
  }

  public updateThumbnail(thumbnail: File) {
    return HttpService.post("/user/api/v1/users/thumbnail", {
      body: { thumbnail },
      requestContentType: RequestContentType.MULTIPART,
    });
  }

  public updateFavoriteCategories(categoryIds: number[]) {
    return HttpService.post("/user/api/v2/user-categories-relation", {
      body: { categoryIds },
    });
  }
}

const UserService = new _UserService();

export default UserService;
